// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Input-module__main--jhi3w {
    border: 1px solid var(--color-secondary-light);
    border-radius: 12px;
    padding: 6px 12px;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: var(--color-general-black);
}

.Input-module__main--jhi3w.Input-module__error--hQnXg {
    border-color: var(--color-status-error);
}

.Input-module__smallWidth--al74J {
    max-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Input/Input.module.css"],"names":[],"mappings":"AAAA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".main {\n    border: 1px solid var(--color-secondary-light);\n    border-radius: 12px;\n    padding: 6px 12px;\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 500;\n    color: var(--color-general-black);\n}\n\n.main.error {\n    border-color: var(--color-status-error);\n}\n\n.smallWidth {\n    max-width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Input-module__main--jhi3w`,
	"error": `Input-module__error--hQnXg`,
	"smallWidth": `Input-module__smallWidth--al74J`
};
export default ___CSS_LOADER_EXPORT___;
